import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// Import role-specific dashboards
import SuperAdminDashboard from './dashboards/SuperAdminDashboard';
import CountryAdminDashboard from './dashboards/CountryAdminDashboard';
import PartnerDashboard from './dashboards/PartnerDashboard';
import ClientDashboard from './dashboards/ClientDashboard';
import LocalPartnerDashboard from './dashboards/LocalPartnerDashboard';
import LoaderDashboard from './dashboards/LoaderDashboard';

const Dashboard = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-lg text-gray-600">{t('loading')}</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  // Render the appropriate dashboard based on user role
  switch (user.role) {
    case 'platform_admin':
      return <SuperAdminDashboard />;
    case 'super_admin':
    case 'company_admin':
      return <SuperAdminDashboard />;
    case 'country_admin':
      return <CountryAdminDashboard />;
    case 'partner':
      return <PartnerDashboard />;
    case 'local_partner':
      return <LocalPartnerDashboard />;
    case 'loader':
      return <LoaderDashboard />;
    case 'client':
      return <ClientDashboard />;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <p className="text-lg text-red-600">{t('roleNotRecognized')}: {user.role}</p>
        </div>
      );
  }
};

export default Dashboard;
